import React from 'react';
import './UserProfilePanelSkeletons.css';

const DEFAULT_ROW_COUNT = 5;

function SkeletonRows({ count, renderRow, listClassName, listAriaHidden = true }) {
  return (
    <ul className={listClassName} aria-hidden={listAriaHidden || undefined}>
      {Array.from({ length: count }, (_, index) => renderRow(index))}
    </ul>
  );
}

/** Profile → Roles tab loading placeholder */
export function UserProfileRolesListSkeleton({ rows = DEFAULT_ROW_COUNT }) {
  return (
    <SkeletonRows
      count={rows}
      listClassName="user-profile-panel-skeleton__list user-profile-roles-panel__list"
      renderRow={(index) => (
        <li key={`roles-skeleton-${index}`} className="user-profile-roles-panel__item">
          <div className="user-profile-panel-skeleton__roles-card">
            <div className="user-profile-panel-skeleton__roles-header">
              <div className="user-profile-panel-skeleton__roles-primary-row">
                <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__roles-icon" />
                <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__roles-title" />
                <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__roles-pill" />
              </div>
              <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__roles-promise" />
            </div>
          </div>
        </li>
      )}
    />
  );
}

/** Profile → Tracks tab loading placeholder */
export function UserProfileTracksListSkeleton({ rows = DEFAULT_ROW_COUNT }) {
  return (
    <SkeletonRows
      count={rows}
      listClassName="user-profile-panel-skeleton__list user-profile-achievements-list"
      renderRow={(index) => (
        <li key={`tracks-skeleton-${index}`} className="user-profile-achievements-list__list-item">
          <div className="user-profile-panel-skeleton__tracks-card">
            <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__tracks-icon" />
            <div className="user-profile-panel-skeleton__tracks-body">
              <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__tracks-title" />
              <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__tracks-progress" />
            </div>
          </div>
        </li>
      )}
    />
  );
}

/** Profile → Mastered snippets tab loading placeholder */
export function UserProfileMasteredSnippetsListSkeleton({ rows = DEFAULT_ROW_COUNT }) {
  return (
    <div className="user-profile-mastered-snippets-list" aria-busy="true" aria-label="Loading mastered snippets">
      <SkeletonRows
        count={rows}
        listClassName="user-profile-panel-skeleton__list user-profile-mastered-snippets-list__items"
        listAriaHidden={false}
        renderRow={(index) => (
          <li
            key={`mastered-skeleton-${index}`}
            className="user-profile-mastered-snippets-list__item user-profile-panel-skeleton__mastered-item"
          >
            <div className="user-profile-mastered-snippets-list__body">
              <div className="user-profile-panel-skeleton__mastered-title-row">
                <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__mastered-icon" />
                <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__mastered-title" />
              </div>
              <span className="user-profile-panel-skeleton__block user-profile-panel-skeleton__mastered-deck" />
            </div>
          </li>
        )}
      />
    </div>
  );
}
